export const translations = (t) => ({
  rowsText: t('reactTable.rowsText'),
  ofText: t('reactTable.ofText'),
  previousText: t('reactTable.previousText'),
  nextText: t('reactTable.nextText'),
  loadingText: t('reactTable.loadingText'),
  noDataText: t('reactTable.noDataText'),
})
